import { PopupFeedApi } from '@api';
import { popupFeedTypes as actionTypes } from './types';

export const fetchPopupFeeds = (locale) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  PopupFeedApi.getList({ locale })
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: { [locale]: response },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
